import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import track from 'utils/track';
import api from 'utils/api';
import { setAlert, setSuccessAlert } from 'actions/alerts';
import { playlistQueryKeys } from 'actions/playlists';
import { assetQueryKeys } from 'actions/assets';
import contentKeys from './queryKeys';
function saveContent(_x) {
  return _saveContent.apply(this, arguments);
}
function _saveContent() {
  _saveContent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var id, isAsset, method, path, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          id = _ref.id, isAsset = _ref.isAsset;
          method = isAsset ? 'post' : 'put';
          path = isAsset ? "/api/me/assets/".concat(id, "/save/") : "/api/me/playlists/".concat(id, "/save/");
          _context2.next = 5;
          return api(method, path, null);
        case 5:
          data = _context2.sent;
          return _context2.abrupt("return", data);
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _saveContent.apply(this, arguments);
}
function unsaveContent(_x2) {
  return _unsaveContent.apply(this, arguments);
}
function _unsaveContent() {
  _unsaveContent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref2) {
    var id, isAsset, method, path, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          id = _ref2.id, isAsset = _ref2.isAsset;
          method = isAsset ? 'delete' : 'put';
          path = isAsset ? "/api/me/assets/".concat(id, "/unsave/") : "/api/me/playlists/".concat(id, "/unsave/");
          _context3.next = 5;
          return api(method, path, null);
        case 5:
          data = _context3.sent;
          return _context3.abrupt("return", data);
        case 7:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _unsaveContent.apply(this, arguments);
}
function useToggleSaveMyContent(_ref3) {
  var id = _ref3.id,
    isRecommended = _ref3.isRecommended,
    isAsset = _ref3.isAsset,
    isSaved = _ref3.isSaved,
    options = _ref3.options;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  var queryFn = isSaved ? saveContent : unsaveContent;
  var onUndo = isSaved ? unsaveContent : saveContent;
  var _useMutation = useMutation(queryFn, _objectSpread(_objectSpread({}, options), {}, {
      onSuccess: function onSuccess() {
        var title;
        if (isAsset) {
          if (isSaved) {
            track('asset', 'favourite', id);
            title = t('saved_for_later_confirmation');
          } else {
            track('asset', 'unfavourite', id);
            title = t('saved_for_later_delete_confirmation');
          }
        } else {
          if (isSaved) {
            track('collection', 'saved', isRecommended ? 'recommended' : undefined, +id);
            title = t('alert_save_msg');
          } else {
            track('collection', 'unsaved', id);
            title = t('alert_remove_from_saved_msg');
          }
        }
        queryClient.invalidateQueries(assetQueryKeys.assets);
        queryClient.invalidateQueries(assetQueryKeys.allAssetAnalytics);
        queryClient.invalidateQueries(playlistQueryKeys.allPlaylists);
        queryClient.invalidateQueries(playlistQueryKeys.allPlaylistAnalytics);
        queryClient.invalidateQueries(contentKeys.allContent);
        setSuccessAlert({
          key: "fav-".concat(id),
          title: title,
          cta: {
            title: t('actions_undo'),
            onClick: function () {
              var _onClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return onUndo({
                        id: id,
                        isAsset: isAsset
                      });
                    case 2:
                      queryClient.invalidateQueries(assetQueryKeys.assets);
                      queryClient.invalidateQueries(playlistQueryKeys.allPlaylists);
                      queryClient.invalidateQueries(contentKeys.allContent);
                    case 5:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              function onClick() {
                return _onClick.apply(this, arguments);
              }
              return onClick;
            }()
          }
        });
      },
      onError: function onError() {
        setAlert({
          title: t('error')
        });
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded);
  return _objectSpread(_objectSpread({}, result), {}, {
    toggleSaveContent: mutateAsync
  });
}
export default useToggleSaveMyContent;